export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00162.54e42591.png";